var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buy-log-view"},[_c('BuyLogList',{attrs:{"buys":_vm.dailyBuys,"loading":_vm.isLoading},on:{"click:buy":_vm.onBuyClick}}),_c('router-view',{attrs:{"name":"reportDialog"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }